<script lang="ts">
    import intersectionObserver from "@ui-utils/actions/intersectionObserver";
    import { createEventDispatcher } from "svelte";

    import Spinner from "@components/Spinner/Spinner.svelte";

    //Props
    export let hasNext: boolean;
    export let loading: boolean;

    //Optional props
    export let options: IntersectionObserverInit | undefined = undefined;

    //Dispatcher
    const dispatch = createEventDispatcher();
</script>

{#if hasNext}
    <div
        class="gw-infinite-scroll-container"
        use:intersectionObserver={options}
        on:viewportEnter={() => dispatch("loadMore")}
    >
        {#if loading}
            <Spinner size="30px" color="var(--gw-blue-text-color)" />
        {/if}
    </div>
{/if}

<style lang="postcss">
    .gw-infinite-scroll-container {
        display: grid;
        place-content: center;
        margin-block: var(--gw-space-6);
    }
</style>
